import { render, staticRenderFns } from "./RecentEventsWidget.vue?vue&type=template&id=66b0e047&"
import script from "./RecentEventsWidget.vue?vue&type=script&lang=js&"
export * from "./RecentEventsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports